import { AppRouteProps } from "@bsm/component";
import EmailConfigureContainer from "../configure/container/EmailConfigureContainer";

export const EmailEditRoutes: Array<AppRouteProps> = [
    {
        path: ":id/edit",
        element: <EmailConfigureContainer />,
    },
];